<div class="form-step__subheading">
  To confirm the information from the previous page, we will send you a security code. How would you
  like to receive your security code?
</div>

@if(!!user) {
  <form class="typeform rkt-Fieldset">
    <mat-radio-group>
      <div>
        @if(user.phoneNumber !== null) {
          <div>
            <mat-radio-button
              (change)="selectMultiFactorChallenge($event)"
              [checked]="selectedMultiFactorChallenge === multiFactorChallengeOptions.SMS"
              [value]="multiFactorChallengeOptions.SMS"
              class="rkt-Radio"
              name="selectedChallengeType"
              >
              <span data-testid="sms-option"> Text: (***) ***-{{ user.phoneNumber }} </span>
            </mat-radio-button>
          </div>

          <div>
            <mat-radio-button
              (change)="selectMultiFactorChallenge($event)"
              [checked]="selectedMultiFactorChallenge === multiFactorChallengeOptions.PHONE"
              [value]="multiFactorChallengeOptions.PHONE"
              class="rkt-Radio"
              name="selectedChallengeType"
              >
              <span data-testid="call-option"> Call: (***) ***-{{ user.phoneNumber }} </span>
            </mat-radio-button>
          </div>
          } @if(user.emailAddress !== null) {
          <div>
            <mat-radio-button
              (change)="selectMultiFactorChallenge($event)"
              [checked]="selectedMultiFactorChallenge === multiFactorChallengeOptions.EMAIL"
              [value]="multiFactorChallengeOptions.EMAIL"
              class="rkt-Radio"
              name="selectedChallengeType"
              >
              <span data-testid="email-option"> Email: {{ user.emailAddress }} </span>
            </mat-radio-button>
          </div>
        }
      </div>
    </mat-radio-group>

    @if (errorMessage$ | async; as errorMessage) {
      <div class="error-message">
        {{ errorMessage }}
      </div>
    }

    <app-button-container>
      <app-button
        type="primary"
        (click)="saveSelection()"
        [dataTestId]="'next-button-verifysignerdetails'"
        >
        Send
      </app-button>
    </app-button-container>
  </form>
}
